/**
 * Centralized PDF.js worker configuration
 * This ensures all PDF.js instances use the same self-hosted worker
 */

/**
 * Get the self-hosted PDF.js worker URL
 * Using Vite's ?url import ensures the worker file is properly bundled
 * and the URL is correctly resolved in both dev and production builds
 */
// @ts-ignore - Vite handles ?url imports at build time
import pdfjsWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

export const PDFJS_WORKER_SRC = pdfjsWorkerUrl;

// Set worker immediately at module load (synchronous)
// This runs ONCE before any component mounts, preventing race conditions
import { GlobalWorkerOptions } from "pdfjs-dist";
GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;

export async function getPdfjsLib() {
  const pdfjsLib = await import("pdfjs-dist");
  return pdfjsLib;
}
